import React from 'react';

const HomeMigrar1 = ({styles, handleClickMigBarr, handleClickMigServ, handleClickMigTar,
                      handleClickMigCli, handleClickMigDir, handleClickMigTarCli, handleClickMigMovCli,
                      handleClickMigUpdRM, handleClickMigEquipo}) => {
  return (
    <div>
      <button className="ui right labeled icon button fluid" style={styles.titBuscar}>
        <i className="large settings yellow icon"></i>
        MIGRACION
      </button>

      {/* <button className="ui labeled icon button fluid" style={styles.dropdown} onClick={handleClickMigBarr}>
        <i className="large check violet icon"></i>
        Barrios
      </button> */}
      {/* <button className="ui labeled icon button fluid" style={styles.dropdown} onClick={handleClickMigServ}>
        <i className="large check violet icon"></i>
        Servicios
      </button>
      <button className="ui labeled icon button fluid" style={styles.dropdown} onClick={handleClickMigTar}>
        <i className="large check violet icon"></i>
        Tarifas
      </button> */}
      <button className="ui labeled icon button fluid" style={styles.dropdown} onClick={handleClickMigCli}>
        <i className="large check violet icon"></i>
        Clientes
      </button>
      {/* <button className="ui labeled icon button fluid" style={styles.dropdown} onClick={handleClickMigDir}>
        <i className="large check violet icon"></i>
        Dirección Clientes
      </button>
      <button className="ui labeled icon button fluid" style={styles.dropdown} onClick={handleClickMigTarCli}>
        <i className="large check violet icon"></i>
        Tarifa Clientes
      </button>
      <button className="ui labeled icon button fluid" style={styles.dropdown} onClick={handleClickMigMovCli}>
        <i className="large check violet icon"></i>
          Hist y Movim Clientes
      </button>

      <button className="ui labeled icon button fluid" style={styles.dropdown} onClick={handleClickMigUpdRM}>
        <i className="large check violet icon"></i>
        Actualizar renta mensual
      </button>

      <button className="ui labeled icon button fluid" style={styles.dropdown} onClick={handleClickMigEquipo}>
        <i className="large check violet icon"></i>
          Equipos Clientes
      </button> */}
    </div>
  )
};

export default HomeMigrar1
